﻿export const getSatser = async (): Promise<Satser> => {
    const response = await fetch('/api/mt1535/satser/inntektogformue');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface Satser {
    ST04_InntektsgrenseDager211X: number;
    ST04_InntektsgrenseDager0210: number;
    ST04_InntektsgrenseEktefelle: number;
    GrenseForeldreInntekt: number;
    ST04_FormuegrenseEnslig: number;
    ST04_FormuegrenseGift: number;
    ST04_TrygdegrenseDager211X: number;
    ST04_TrygdegrenseDager0210: number;
    ST01_BostipendLaerlingelonnNedreGrenseTrekk: number;
}
